<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CvgtjI/tc-custom/9781429904056.jpg?1730776558773" alt="This image is the cover for the book To The Scaffold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To The Scaffold
      </h1>
      <p class="bookDescription body article font2">
        <p>One of history's most misunderstood figures, Marie Antoinette represents the extravagance and the decadence of pre-Revolution France. Yet there was an innocence about Antoinette, thrust as a child into the chillingly formal French court.<br/><br/>Married to the maladroit, ill-mannered Dauphin, Antoinette found pleasure in costly entertainments and garments. She spent lavishly while her overtaxed and increasingly hostile subjects blamed her for France's plight. In time Antoinette matured into a courageous Queen, and when their enemies finally closed in, Antoinette followed her inept husband to the guillotine in one last act of bravery.<br/><br/>In <i>To the Scaffold</i>, Carolly Erickson provides an estimation of a lost Queen that is psychologically acute, richly detailed, and deeply moving.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolly Erickson
      </h2>
      
      <p class="authorDescription body article"><P>Distinguished historian <B>Carolly Erickson</B> is the author of <I>Rival to the Queen</I>, <I>The Memoirs of Mary Queen of Scots</I>, <I>The First Elizabeth</I>, <I>The Hidden Life of Josephine</I>, <I>The Last Wife of Henry VIII,</I> and many other prize-winning works of fiction and nonfiction. Her novel <I>The Tsarina's Daughter</I> won the <I>Romantic Times</I> Reviewer's Choice Award for Best Historical Fiction. She lives in Hawaii.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22378508